import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { deleteAccountByGroup, editAccountByGroup } from 'RestAPIs/admin';
import { useGetAccountsByGroup } from '../../../../../../../../../queries';
import AccountsInner from './components/AccountsInner';
import schema from './utils/schema';

import type { AxiosResponse } from 'axios';
import type { FC } from 'react';
import type { TabProps } from '../../types';

const Accounts: FC<TabProps> = ({
  setIsNavigationDisabled,
  rows,
  toggleInnerLayout,
  currentViewData,
  setCurrentViewData,
  setIsDirty
}) => {
  'use memo';

  const [deletedIds, setDeletedIds] = useState<number[]>([]);

  const methods = useForm({
    defaultValues: schema.cast({ accounts: [] }),
    resolver: yupResolver(schema)
  });

  const { data: accounts, isFetching } = useGetAccountsByGroup(
    currentViewData.groupId
  );

  useEffect(() => {
    if (accounts) {
      methods.reset(schema.cast({ accounts: accounts }));
    }
  }, [accounts, currentViewData, methods]);

  const handleSubmit = (data) => {
    if (data.accounts) {
      const requestsArray: Promise<AxiosResponse>[] = [];
      data.accounts
        .filter((value) => value.isCommitted)
        .forEach((detail) => {
          requestsArray.push(
            editAccountByGroup(currentViewData.groupId, detail.accountId, {
              ...detail,
              groupId: currentViewData.groupId
            })
          );
        });
      deletedIds.forEach((id) => {
        requestsArray.push(deleteAccountByGroup(currentViewData.groupId, id));
      });

      return Promise.all(requestsArray);
    }

    return Promise.resolve();
  };

  const handleOnCancel = () => {
    setDeletedIds([]);
    methods.reset();
  };

  return (
    <AccountsInner
      setIsNavigationDisabled={setIsNavigationDisabled}
      toggleInnerLayout={toggleInnerLayout}
      rowData={currentViewData}
      rows={rows}
      methods={methods}
      onSubmit={handleSubmit}
      currentViewData={currentViewData}
      setCurrentViewData={setCurrentViewData}
      isFetching={isFetching}
      accounts={accounts}
      setDeletedIds={setDeletedIds}
      onCancel={handleOnCancel}
      setIsDirty={setIsDirty}
    />
  );
};

export default Accounts;
